export const JobNameCellRenderer = ({ value }) => {
  if (!value) return <span />

  let valueStr = value.toString();
  return <span>{valueStr}</span>
}